export class PaidPayment {
    registrationId: string;
    totalAmount: number;
    paymentAccountName: string;
    email: string;
    stripeTokenId: string;
    creditCardName: string;
    expirationDate: string;
    securityCode: string;
    paidProductService: PaymentProductService;
}

export interface PaymentProductService {
    ACEHR: boolean;
    ACScripts: boolean;
    ACBilling: boolean;
}

export interface PaidPaymentResponse {
    message: string;
    success: boolean;
    messageType: string;
}

export class PaymentProduct {
    public id: number;
    public productName: string;
    public amount: number;
}

export enum PaymentProductType {
    ACEHR = 'ACEHR',
    ACScripts = 'ACScripts',
    ACBilling = 'ACBilling'
}


// WEBPACK FOOTER //
// ./src/models/payment.ts